import React from 'react'
import { DatePicker as ShadcnDatePicker } from '@/components/ui/date-picker'

const CustomDatePicker = ({
	date,
	setDate,
	placeholder,
	startDate,
	handleBlur,
	name,
	touched,
	errors,
	isDisabled,
	isFflNumberValid,
}) => {
	// Convert string date to Date object if needed
	const dateValue = date ? new Date(date) : undefined
	const minDate = startDate ? new Date(startDate) : undefined

	const handleDateChange = (newDate) => {
		if (newDate) {
			setDate(newDate.toString())
		} else {
			setDate(undefined)
		}
	}

	return (
		<div className="form-group">
			<ShadcnDatePicker
				date={dateValue}
				onDateChange={handleDateChange}
				placeholder={placeholder}
				disabled={isDisabled}
				minDate={minDate}
			/>
			{isFflNumberValid &&
				!date &&
				errors &&
				errors.expirationDate &&
				touched?.expirationDate && (
					<div className="error-message">{errors.expirationDate}</div>
				)}
		</div>
	)
}

export default CustomDatePicker
